import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { PrimaryButton, SecondaryButton } from "../../components/UIkit";
const OrderingDepartmentMenu = () => {
  const dispatch = useDispatch();

  const transition = useCallback((path) => {
    dispatch(push(path));
  }, []);
  return (
    <div>
      <h2 className="u-text__headline u-text-center">発注拠点と部署</h2>
      <div className="module-spacer--small" />
      <div className="center">
        <PrimaryButton
          label={"拠点を登録する"}
          onClick={() => transition("/ordering-department/base-edit")}
        />
      </div>
      {/* <TextDetail label="ユーザー名" value={username} /> */}
      <div className="module-spacer--small" />
      <div className="center">
        {/* <SecondaryButton label={"カード情報の編集"} onClick={() => transition('/user/payment/edit')} /> */}
        <SecondaryButton
          label={"部署を登録する"}
          onClick={() => transition("/ordering-department/department-edit")}
        />
      </div>
    </div>
  );
};

export default OrderingDepartmentMenu;
